<template>
  <div class="page pt-5 pb-10">
    <v-row>
      <v-col class="col-sm-12 col-md-4 col-12 col-filter-container pt-md-6">
        <div class="col-filter">

          <v-text-field
              v-model="filterKeyword"
              label="Search keyword"
              clearable
              @input="filterOnKeyword"
              class="keyword-input"
          ></v-text-field>

          <div class="items-total">Total items found: {{filteredItems.length}}
            <div class="reset-filters" @click="resetFilters">Reset all</div>
          </div>


          <div class="current-filters" v-if="currentFilters.length">
            <div class="title">Currently filtered by:</div>
            <div class="filters">
              <div v-for="(filter, index) in currentFilters"
                   :key="`filter-`+index"
                   class="filter">
                {{filter}} <v-icon small color="primary" @click="clickRemoveFilter(filter)">mdi-close-circle-outline</v-icon>
              </div>
            </div>
            <div class="clearer"></div>
          </div>
          <v-expansion-panels focusable flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Publication category
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                    v-for="(category, index) in categories"
                    :key="`cat-`+index"
                >
                  <v-checkbox
                      v-model="filterCategories"
                      :label="category.name"
                      :value="category.name"
                      @click="clickCheckbox"
                  ></v-checkbox>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                Type of study
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                    v-for="(type, index) in types"
                    :key="`cat-`+index"
                >
                  <v-checkbox
                      v-model="filterTypes"
                      :label="type.name"
                      :value="type.name"
                      @click="clickCheckbox"
                  ></v-checkbox>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                Related to product
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                    v-for="(product, index) in products"
                    :key="`prod-`+index"
                >
                  <v-checkbox
                      v-model="filterProducts"
                      :label="product.name"
                      :value="product.name"
                      @click="clickCheckbox"
                  ></v-checkbox>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </div>
      </v-col>
      <v-col class="col-sm-12 col-md-8 col-12 ">
        <v-pagination
            v-if="!hidePager"
            v-model="currentPage"
            :length="totalPages"
            total-visible="8"
            @input="updateVisibleItems"
            @previous="updateVisibleItems"
            @next="updateVisibleItems"
            class="pager pb-4"
        ></v-pagination>
        <div v-if="loading" class="loading-message pubmed-entry">Loading articles...</div>
        <div v-if="!loading && !filteredItems.length" class="loading-message pubmed-entry">
          No articles meet your search criteria.
        </div>
        <div v-for="(entry,id) in itemsVisible" v-bind:key="`entry-`+id">
          <PubMedEntry :entry="entry" />
        </div>

        <v-pagination
            v-if="!hidePager"
            v-model="currentPage"
            :length="totalPages"
            total-visible="8"
            @input="updateVisibleItems"
            @previous="updateVisibleItems"
            @next="updateVisibleItems"
            class="pt-4"
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PubMedEntry from "@/components/PubMedEntry";
export default {
  name: "Page",
  components: {PubMedEntry  },
  data() {
    return {
      entries: [],
      filteredItems: [],
      itemsVisible: [],
      categories: [],
      products: [],
      types: [],
      currentFilters: [],
      filterCategories: [],
      filterTypes: [],
      filterProducts: [],
      filterKeyword: '',
      loading: true,
      totalPages: 1,
      currentPage: 0,
      entriesPerPage: 10,
      hidePager: false,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData(){
      this.loading = true
      const apiUrl = process.env.VUE_APP_API_URL + 'articles'
      await this.$axios.get(apiUrl)
          .then((result) => {
            // console.log('articles',result)
            this.entries = result.data.articles
            this.performFilterOnItems()
          }).catch(()=>{
      })
      await this.$axios.get(apiUrl + '/categories')
          .then((result) => {
            // console.log('categories',result)
            this.categories = result.data
          }).catch(()=>{
          })
      await this.$axios.get(apiUrl + '/products')
          .then((result) => {
            console.log('products',result)
            this.products = result.data
          }).catch(()=>{
          })
      await this.$axios.get(apiUrl + '/types')
          .then((result) => {
            console.log('types',result)
            this.types = result.data
          }).catch(()=>{
          })
      this.loading = false
    },
    clickCheckbox(){
      this.setCurrentFilters()
      this.performFilterOnItems()
    },
    clickRemoveFilter(filter){
      console.log('clickRemoveFilter', filter)
      if(this.filterCategories.indexOf(filter) > -1){
        this.filterCategories.splice(this.filterCategories.indexOf(filter), 1)
      }else if(this.filterProducts.indexOf(filter) > -1){
        this.filterProducts.splice(this.filterProducts.indexOf(filter), 1)
      }else if(this.filterTypes.indexOf(filter) > -1){
        this.filterTypes.splice(this.filterTypes.indexOf(filter), 1)
      }
      this.setCurrentFilters()
      this.performFilterOnItems()
    },
    setCurrentFilters(){
      const newFilter = []
      this.currentFilters = newFilter.concat(this.filterCategories, this.filterProducts, this.filterTypes)
    },
    filterOnKeyword() {
      console.log('filterOnKeyword', this.filterKeyword)
      this.performFilterOnItems()
    },
    resetFilters(){
      this.currentFilters = []
      this.filterCategories = []
      this.filterProducts = []
      this.filterTypes = []
      this.filterKeyword = ''
      this.performFilterOnItems()
    },
    updateVisibleItems(){
      this.itemsVisible = this.filteredItems.slice((this.currentPage - 1) * this.entriesPerPage, (this.currentPage)*this.entriesPerPage)
    },
    performFilterOnItems() {
      let tempItems = JSON.parse(JSON.stringify(this.entries))
      tempItems = this.filterByKeyword(tempItems)
      tempItems = this.filterByCategories(tempItems)
      tempItems = this.filterByProducts(tempItems)
      tempItems = this.filterByTypes(tempItems)
      tempItems = this.sortItems(tempItems)
      this.filteredItems = tempItems
      this.currentPage = 1
      this.totalPages = Math.ceil(this.filteredItems.length / this.entriesPerPage)
      // if(this.totalPages > 1){
      //   this.hidePager = false
      // }else{
      //   this.hidePager = true
      // }
      this.updateVisibleItems()
    },
    sortItems(items) {
      let sortedItems = items
      sortedItems = sortedItems.sort((a, b) => {
        const fa = a.title.toLowerCase().replace(/['"]+/g, '')
        const fb = b.title.toLowerCase().replace(/['"]+/g, '')
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
      return sortedItems
    },
    filterByCategories(items){
      if (!this.filterCategories.length) return items

      const filteredItems = []
      for (const item of items) {
        const itemCategories = []
        let hasCategories = true
        for (const category of item.categories) {
          itemCategories.push(category.name)
        }
        for (const catCheck of this.filterCategories) {
          if (!itemCategories.includes(catCheck)) {
            hasCategories = false
          }
        }
        if (hasCategories) {
          filteredItems.push(item)
        }
      }
      console.log('filteredItems', filteredItems)
      return filteredItems
    },
    filterByTypes(items){
      if (!this.filterTypes.length) return items

      const filteredItems = []
      for (const item of items) {
        const itemTypes = []
        let hasTypes = true
        for (const _type of item.types) {
          itemTypes.push(_type.name)
        }
        for (const typeCheck of this.filterTypes) {
          if (!itemTypes.includes(typeCheck)) {
            hasTypes = false
          }
        }
        if (hasTypes) {
          filteredItems.push(item)
        }
      }
      console.log('filteredItems', filteredItems)
      return filteredItems
    },
    filterByProducts(items){
      if (!this.filterProducts.length) return items

      const filteredItems = []
      for (const item of items) {
        const itemProducts = []
        let hasProducts = true
        for (const product of item.products) {
          itemProducts.push(product.name)
        }
        for (const catCheck of this.filterProducts) {
          if (!itemProducts.includes(catCheck)) {
            hasProducts = false
          }
        }
        if (hasProducts) {
          filteredItems.push(item)
        }
      }
      console.log('filteredItems', filteredItems)
      return filteredItems
    },
    filterByKeyword(items) {
      if (!this.filterKeyword) return items

      let tempItems = items
      tempItems = tempItems.filter((item) => {
        return (
            (item.title &&
                item.title.toLowerCase().includes(
                    this.filterKeyword.toLowerCase()
                )) ||
            (item.authors &&
                item.authors.toLowerCase().includes(
                    this.filterKeyword.toLowerCase()
                )) ||
            (item.abstract_full &&
                item.abstract_full.toLowerCase().includes(
                    this.filterKeyword.toLowerCase()
                ))
        )
      })
      return tempItems
    },
  },
};
</script>

<style scoped>
</style>
